<template>
  <div>
    <router-view v-show="$route.matched.length == 3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length == 2">
      <div class="main-page-content">
        <el-row class="table-header-gai">
          <el-col>
            <el-button
              v-if="
                userPermissions.indexOf('individual_invitation') != -1 &&
                regFlag == true
              "
              size="medium"
              type="primary"
              class="cusomer-link-gai"
              @click="getCode"
              icon="el-icon-paperclip"
              >生成集群注册邀请码</el-button
            >
          </el-col>
          <el-col>
            <div type="primary" size="medium" class="total-num">
              已收集人数：<span class="span-num">{{
                this.pagingData.total
              }}</span>
            </div>
          </el-col>
          <!-- <div class="people-btn-wrapper">
            <el-button v-if="userPermissions.indexOf('customer_import') != -1" style="color: #1890ff" size="medium"  @click="importExcel" icon="iconfont el-icon-upload">人才Excel导入</el-button>
            <el-button type="text" size="medium" @click="mxGoUrl(mxGetOssUrl('/sample/excel/%E4%BA%BA%E6%89%8D%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx', true))">
              人才导入模板.xlsx
            </el-button>
          </div> -->
        </el-row>
        <!-- <el-row class="table-header">
          <el-col>
            <el-tooltip effect="dark" style="margin-left:20px"  content="创建账户" placement="top-start"  v-if="userPermissions.indexOf('customer_create') != -1 && buttonType=='icon'" >
              <el-button type="primary" size="medium" icon="iconfont icon-tianjiacaidan2" @click="addButton(0)"></el-button>
            </el-tooltip>
            <el-button v-if="userPermissions.indexOf('customer_import') != -1" type="primary" size="medium"  @click="importExcel" icon="iconfont el-icon-upload">人才Excel导入</el-button>
            <el-button type="text" size="medium" @click="mxGoUrl('https://img.51xinlong.com/xladmin/sample/excel/%E4%BA%BA%E6%89%8D%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx')">
              人才导入模板.xlsx
            </el-button>
          </el-col>
        </el-row> -->
        <el-row style="height: 36px">
          <el-form size="medium" :inline="true" :model="searchCondition">
            <el-form-item label="姓名">
              <el-input
                @input="searchButton"
                v-model="searchCondition.name"
                placeholder="输入姓名"
                class="item-name"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="办理状态">
              <el-select
                v-model="searchCondition.status"
                filterable
                clearable
                :multiple-limit="1"
                placeholder="请选择"
                class="selectWord"
                @change="searchButton"
              >
                <el-option
                  v-for="item in options"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="时间">
              <DatePicker @dataSearch="dataSearch" />
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="searchButton">查询</el-button>
            </el-form-item>
            <!-- <div class="table-right">
              <el-form-item>
                <el-select v-model="exportSelect"  @change="changeExportOption" class="select-box">
                  <el-option
                    v-for="item in exportOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button :loading="downloadLoading" type="primary" icon="el-icon-document" @click="handleDownload">
                  导出
                </el-button>
              </el-form-item>
            </div> -->
          </el-form>
        </el-row>
        <!--代开发票邀请码-->
        <el-dialog
          width="40%"
          :title="'注册邀请码'"
          :close-on-click-modal="false"
          :visible.sync="invoiceVisible"
          append-to-body
        >
          <div class="dialog-title">
            <i
              class="el-icon-success"
              style="font-size: 40px; color: #409eff"
            ></i>
            <span class="title-text"
              >打开微信扫一扫或前往手机端小程序【灵活就业网】填写邀请码！</span
            >
          </div>
          <div class="center-box">
            <div class="code">
                <img :src="this.OrImage" class="QR-code" v-if="this.OrImage" />
                <div class="tips">
                    打开微信[扫一扫]
                </div>
            </div>
            <div class="alipay-code code">
                <img :src="this.alipayOrImage" class="QR-code" v-if="this.alipayOrImage" />
                <div class="tips">
                    打开支付宝[扫一扫]
                </div>
            </div>
          </div>
          <div class="centerbox">
            <div class="label">手动邀请码</div>
            <div class="QR-box">
              <!--              < img :src="this.OrImage" class="QR-code" v-if="this.OrImage"/>-->
              <div class="inviteCodes">{{ inviteCode }}</div>
            </div>
            <el-button
              class="copyBtn"
              plain
              v-clipboard:copy="inviteCode"
              v-clipboard:success="copySuccess"
            >
              复制
            </el-button>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeQRDialog" size="medium"
              >确定</el-button
            >
          </div>
        </el-dialog>
        <ApeTable
          ref="apeTable"
          :data="companyList"
          :columns="columns"
          :loading="loadingStaus"
          :pagingData="pagingData"
          @switchPaging="switchPaging"
          highlight-current-row
        >
          <el-table-column
            v-if="buttonType == 'text'"
            width="160"
            header_align="center"
            align="center"
            label="操作"
          >
            <template slot-scope="scope">
              <span>
                <el-button
                  size="mini"
                  type="default"
                  v-if="userPermissions.indexOf('individual_view') != -1"
                  @click="viewButton(scope.row.id)"
                  >详情</el-button
                >
                <!-- <el-button size="mini" type="default" v-if="userPermissions.indexOf('individual_edit') != -1"  @click="editButton(scope.row.id)">编辑</el-button> -->
                <el-popover
                  v-if="userPermissions.indexOf('individual_delete') != -1"
                  placement="top"
                  width="150"
                  v-model="scope.row.visible"
                >
                  <p>确定要删除记录吗？</p>
                  <div style="text-align: right; margin: 0">
                    <el-button
                      type="text"
                      size="mini"
                      @click="scope.row.visible = false"
                      >取消</el-button
                    >
                    <el-button
                      type="danger"
                      size="mini"
                      @click="deleteButton(scope.row.id)"
                      >确定</el-button
                    >
                  </div>
                  <el-button slot="reference" type="danger" size="mini"
                    >删除</el-button
                  >
                </el-popover>
              </span>
            </template>
          </el-table-column>
        </ApeTable>
      </div>
      <!-- <div class="people-btn-wrapper">
        <el-button v-if="userPermissions.indexOf('customer_import') != -1" style="color: #1890ff" size="medium"  @click="importExcel" icon="iconfont el-icon-upload">人才Excel导入</el-button>
        <el-button type="text" size="medium" @click="mxGoUrl(mxGetOssUrl('/sample/excel/%E4%BA%BA%E6%89%8D%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx', true))">
          人才导入模板.xlsx
        </el-button>
      </div> -->
      <!-- <div class="people-btn-wrapper" v-if="this.is_import == 1">
        <el-button v-if="userPermissions.indexOf('customer_import') != -1" style="color: #1890ff" size="medium"  @click="importExcel" icon="iconfont el-icon-upload">人才Excel导入</el-button>
        <el-button type="text" size="medium" @click="mxGoUrl(mxGetOssUrl('/sample/excel/%E4%BA%BA%E6%89%8D%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx', true))">
          人才导入模板.xlsx
        </el-button>
      </div> -->
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ApeTable from "@/components/ApeTable";
import DatePicker from "@/components/DatePicker.vue";
import { mapGetters, mapState } from "vuex";

export default {
  components: {
    PageHeaderLayout,
    ApeTable,
    DatePicker,
  },
  data() {
    return {
      inviteCode: "",
      invoiceVisible: false,
      regFlag: false,
      checkList: ["选中且禁用", "复选框 A"],
      //选择签约类型
      options: [
        {
          id: "",
          value: "全部",
        },
        {
          id: "1",
          value: "审核中",
        },
        {
          id: "2",
          value: "审核完成",
        },
        {
          id: "3",
          value: "审核失败",
        },
      ],
      value: "",
      // element的cascader的props值
      cascaderProps: {
        label: "display_name",
        value: "id",
      },
      searchCategory: [],
      // 搜索条件
      searchCondition: {},
      loadingStaus: true,
      columns: [
        // {
        //   title: 'ID',
        //   value: 'id',
        //   width: 170,
        //   header_align: 'center',
        //   align: 'center',
        // },
        {
          title: "身份信息",
          width: 360,
          header_align: "center",
          // align: 'left',
          value: [
            { label: "姓名：", value: "name", width: 100 },
            { label: "身份证号：", value: "idcard", width: 100 },
            { label: "身份证地址：", value: "address", width: 100 },
            { label: "邮箱：", value: "email", width: 100 },
          ],
        },
        {
          title: "银行信息",
          header_align: "center",
          align: "center",
          value: [
            { label: "开户行：", value: "bank" },
            { label: "银行卡：", value: "bank_card" },
          ],
          // valueTemplate: '<span style="font-size:31px">{row}</span>',
          // valueTemplate: '<el-tag>{row}</el-tag>',
        },
        {
          title: "公司名",
          value: "company_name",
          header_align: "center",
          align: "center",
        },
        {
          title: "手机号",
          header_align: "center",
          align: "center",
          // type: 'image',
          value: "mobile",
        },
        {
          title: "身份证正面照片",
          type: "image",
          value: "idcard_front",
          header_align: "center",
          align: "center",
        },
        {
          title: "身份证反面照片",
          type: "image",
          value: "idcard_back",
          header_align: "center",
          align: "center",
        },
        {
          title: "状态",
          value: "alias_status",
          header_align: "center",
          align: "center",
        },
        {
          title: "驳回原因",
          value: "remark",
          header_align: "center",
          align: "center",
        },
        {
          title: "创建时间",
          value: "created_at",
          header_align: "center",
          align: "center",
          /*  width: 180 */
        },
      ],
      // 表格列表数据
      companyList: [],
      // 分页信息
      pagingData: {
        is_show: true,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
      },
      // 分页的offset,序号列使用
      offset: 0,
      // 已上传文件列表
      uploadFileList: [],
      // 表单验证
      rules: {
        title: [{ required: true, message: "输入标题", trigger: "blur" }],
        type: [{ required: true, message: "选择类型", trigger: "blur" }],
        is_new_win: [
          { required: true, message: "选择打开发方式", trigger: "blur" },
        ],
        is_show: [{ required: true, message: "选择状态", trigger: "blur" }],
        image: [
          {
            required: true,
            message: "上传图片",
            trigger: "blur",
            validator: this.apeUploaderVerify,
          },
        ],
      },
      // 附件列表
      attachmentList: [],
      // 附件列表字段定义
      attachmentColumns: [
        {
          title: "标题",
          value: "title",
        },
      ],
      // 添加附件
      dialogData: {
        visible: false,
        title: "",
        width: "24%",
        loading: true,
        modal: false,
      },
      // 附件表单内容
      formData: {},
      // 附件添加表单验证
      dialogRules: {
        title: [{ required: true, message: "输入标题", trigger: "blur" }],
      },
      // 附件类型
      attachmentType: [
        "application/pdf",
        "application/caj",
        "",
        "application/zip",
        "application/rar",
        "application/doc",
      ],
      // 已上传附件列表
      attachmentUploadFileList: [],
      // 当前需要操作附件的文章id
      currentCompanyId: 0,
      isCheck: false, //是否禁用确定按钮
      category_Id: "",
      id: "",
      OrImage: "",
      alipayOrImage:"",
      is_import: "",
      exportOptions: [
        {
          value: "xlsx",
          label: "xlsx",
        },
        {
          value: "csv",
          label: "csv",
        },
        {
          value: "txt",
          label: "txt",
        },
      ],
      //导出表格类型
      exportType: "xlsx",
      downloadLoading: false,
      exportSelect: "xlsx",
    };
  },

  computed: {
    ...mapGetters(["userPermissions", "buttonType"]),
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },
  watch: {
    "$route.matched": function (n, o) {
      console.log(o);
      if (n.length === 2) {
        this.init();
      }
    },
  },
  methods: {
    //复制邀请码
    copySuccess() {
      this.$message({
        type: "success",
        message: "复制成功！",
      });
    },
    //生成邀请码
    async getCode() {
      this.createCode();
    },
    // 创建邀请码
    async createCode() {
      let param = {
        wechat_path:"pages/colony/manageIdcard",
        wechat_appId:this.mxDomain.appId,
        alipay_appId:this.mxDomain.alipayAppId,
        alipay_path:"/pages/colony/manageIdcard",
      };
      let res = await this.$api.getRegisterQrCode(param);
      if (res) {
        this.OrImage = res.wechatCode;
        this.alipayOrImage = res.aliQrCode;
        this.inviteCode = res.inviteCode;
      }
      this.invoiceVisible = true;
    },
    changeExportOption(e) {
      this.exportType = e;
    },
    async handleDownload() {
      this.downloadLoading = true;
      let list = await this.init("export");
      import("@/excel/Export2Excel").then((excel) => {
        let sHeader = {
          id: "【签约ID】",
          name: "【姓名】",
          cardType: "【证件类型(1:身份证2:港澳台通行证3：护照4：军官证)】",
          idCard: "【身份证号码】",
          phone: "【手机号码】",
          bankCard: "【账号(银行卡号或支付宝邮箱账号)】",
          type: "【下发类型(OTHERBANK:银行卡;ALIPAY:支付宝)】",
          categoryName: "【签约类型】",
          companyName: "【公司名称】",
          channelName: "【服务公司名称】",
          createdAt: "【创建时间】",
        };
        const data = this.formatJson(list);
        data.unshift(Object.values(sHeader));
        console.log(data, "data");
        const time = new Date().getTime() + Math.random() * 1000;
        let filename = `人才签约${time}`;
        excel.export_json_to_excel({
          header: Object.keys(sHeader), //Header Required
          data, //Specific data Required
          filename: filename, //Optional
          autoWidth: true, //Optional
          bookType: this.exportType, //Optional
        });
        this.downloadLoading = false;
      });
    },
    formatJson(jsonData) {
      return jsonData.map((v) => {
        let {
          id,
          fullname,
          id_number,
          mobile,
          bank_account_no,
          send_type,
          category_name,
          company_name,
          channel_name,
          created_at,
        } = v;
        return [
          id,
          fullname,
          1,
          id_number,
          mobile,
          bank_account_no,
          send_type,
          category_name,
          company_name,
          channel_name,
          created_at,
        ];
      });
    },
    //关闭二维码弹窗
    closeQRDialog() {
      this.invoiceVisible = false;
    },
    // 搜索
    searchButton() {
      this.init("search");
    },
    // 切换页码操作
    async switchPaging() {
      this.init();
    },
    // 响应添加按钮
    async addButton() {
      // this.$router.push(this.$route.path+'/create')
    },
    // 响应详情按钮
    async viewButton(id) {
      console.log(id);
      this.$router.push(this.$route.path + "/" + id + "/view");
    },
    // 响应编辑按钮
    async editButton(id) {
      console.log(id);
      // this.$router.push(this.$route.path+'/'+id+'/edit')
    },
    // 相应删除按钮
    async deleteButton(id) {
      console.log(id);
      let info = await this.$api.deleteIndividual(id);
      if (info) {
        this.$nextTick(() => {
          this.init("del");
        });
      } else {
        this.$message.error(info);
      }
    },
    //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.time_value = value;
    },
    // 初始化列表
    async init(type) {
      if (type) {
        this.mxResetPage();
      }
      this.loadingStaus = true;
      let pagingInfo = this.$refs["apeTable"].getPagingInfo(type);
      if (type == "search") {
        pagingInfo.current_page = 1;
      }
      if (type == "export") {
        pagingInfo.page_size = 50000;
      } else {
        this.loadingStaus = true;
      }
      let searchCondition = this.handleSearchCondition();
      if (searchCondition.sign_type == "all") {
        delete searchCondition.sign_type;
      }
      Object.assign(searchCondition, pagingInfo);
      let { list, pages } = await this.$api.getIndividualList(searchCondition);

      if (type == "export") {
        this.loadingStaus = false;
        return list;
      } else {
        console.log("list", list);
        this.companyList = list;
        this.pagingData.total = pages.total;
        this.offset = pages.offset;
        this.loadingStaus = false;
      }
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {};
      if (this.searchCondition.name) {
        condition.name = this.searchCondition.name;
      }
      if (this.searchCondition.status) {
        condition.status = this.searchCondition.status;
      }
      if (this.searchCondition.time_value) {
        condition.time = {
          start_time: this.searchCondition.time_value[0],
          end_time: this.searchCondition.time_value[1],
        };
      }
      return condition;
    },
    keyupSubmit() {
      document.onkeydown = (e) => {
        console.log(e);
        let _key = window.event.keyCode;
        if (_key === 13) {
          this.searchButton();
        }
      };
    },
  },
  created() {
    // let { company_id, settlement_id } = this.userInfo
    this.keyupSubmit();
  },
  mounted() {
    let obj = this.$storage.get("dashboard");
    this.regFlag = obj.individual;
    this.init();
  },
};
</script>

<style lang="stylus" scoped>
/deep/.el-checkbox-group label {
  width: 180px;
}

/deep/.el-checkbox-group label:first-child {
  margin-left: 10px;
}

/deep/.el-checkbox-group {
  // width: 660px
}

.el-button {
  margin-right: 4px;
  margin-bottom: 4px;
}

.item-name {
  width: 130px;
}

.table-header-gai {
  height: 35px;
}

.table-header {
  margin-bottom: 12px;
}

.el-popover .el-checkbox-group .el-checkbox {
  margin-left: 0px;
  margin-right: 12px;
}

.returnBtn {
  position: relative;
  top: 10px;
  float: right;
}

.table-right {
  float: right;
}

.submitBtn {
  float: right;
  margin-top: 20px;
}

.link-url {
  color: #fff;
  text-decoration: none;
}

.cusomer-link-gai {
  position: absolute;
  top: 0;
  font-size: 15px;
  width: 180px;
}

.cusomer-link {
  position: absolute;
  top: 0;
  right: 0;
}

.total-num {
  float: right;
  margin-top: 10px;
  margin-right: 20px;
  // position: absolute;
  // top: 0
  // right: 0
  // line-height: 40px
  // padding-right: 20px
}

.span-num {
  color: #f00;
}

.selectWord {
  width: 150px;
}

.link-title {
  text-align: center;
  padding-bottom: 10px;
  color: red;
}

.people-btn-wrapper {
  margin-top: 20px;
}

.dialog-title {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  margin-top: -20px;
}

.title-text {
  font-size: 18px;
  margin-left: 10px;
}

.center-box {
  display: flex;
  justify-content: center;
  align-item: center;
  padding: 30px 0;
}

.code{
    text-align: center;
    display: flex;
    flex-flow: column nowrap;
    justify-content: space-between;
    align-items: center;
    height: 200px;
    overflow: hidden;
    &.alipay-code{
        margin-left: 30px;
        position: relative;
        .QR-code{
            position: relative;
            top: -30px;
            width: 220px;
            height: 220px;
        }
        .tips{
            position: absolute;
            bottom: 0;
        }
    }
    .tips{
        margin-top: 10px;
        font-size: 14px;
        color: #333;
    }
}

.QR-code {
  width: 150px;
  height: 150px;
}

.main-page-content {
  position: relative;
}

.select-box {
  width: 100px;
}

.inviteCode {
  width: 160px;
}

.inviteCodes {
  width: 100%;
  height: 50px;
  line-height: 50px;
  font-size: 20px;
  text-align: center;
  color: #333333;
  border: 1px solid #DADADA;
  border-radius: 5px;
}

.copyBtn {
  width: 100px;
  padding: 10px 0;
  margin:0;
}

.centerbox {
  display: flex;
  align-items: center;
  padding: 20px;
  .QR-box {
    box-sizing: border-box;
    flex:1;
    padding-right: 20px;
  }
  .label{
    margin-right: 20px;
  }
}
</style>
